"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWaitingCustomerAddress = exports.waitingCustomerAddressSchema = void 0;
var yup = require("yup");
exports.waitingCustomerAddressSchema = yup.object().shape({
    firstName: yup.string().optional(),
    lastName: yup.string().optional(),
    company: yup.string().optional(),
    address1: yup.string().required(),
    address2: yup.string().optional(),
    zip: yup.string().required(),
    city: yup.string().required(),
    countryCode: yup.string().required(),
    phone: yup.string().optional(),
    latitude: yup.string().required(),
    longitude: yup.string().required(),
});
function isWaitingCustomerAddress(obj) {
    return exports.waitingCustomerAddressSchema.isValidSync(obj);
}
exports.isWaitingCustomerAddress = isWaitingCustomerAddress;
